import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var CartEmpty = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.963 35.51c0 .6-.5 1-1 1h-3.397c.3.499.4 1.099.4 1.798 0 2.098-1.798 3.896-3.896 3.896-2.198 0-3.897-1.698-3.897-3.896 0-.7.2-1.299.5-1.799H20.282c.3.5.4 1.1.4 1.799 0 2.098-1.699 3.896-3.897 3.896-2.198 0-3.896-1.698-3.896-3.896 0-.7.2-1.299.5-1.799h-.7c-2.098 0-3.797-1.698-3.797-3.696 0-1.599 1.1-2.998 2.498-3.497L5.795 4.638H.999c-.6 0-.999-.5-.999-1 0-.499.5-.998 1-.998h5.594c.5 0 .9.3 1 .799l5.894 25.677h24.078l3.897-18.483H13.987c-.599 0-.999-.5-.999-1 0-.599.5-.999 1-.999h28.974c.3 0 .6.1.799.4.2.2.3.6.2.9l-4.396 20.58c-.1.5-.5.8-1 .8H12.69c-.9 0-1.699.7-1.699 1.599s.7 1.698 1.699 1.698h28.275c.499-.1.999.3.999.9Z"
  }));
});
CartEmpty.displayName = 'CartEmpty';
CartEmpty.defaultProps = {
  'aria-label': 'CartEmpty'
};
export default CartEmpty;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/CartEmpty.js
// module id = 3743
// module chunks = 11